// extracted by mini-css-extract-plugin
module.exports = {"alert":"eGwqZKfd"};